import React, { useState } from 'react';
import moment from "moment"
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import { CSVLink } from "react-csv";

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import { Card, createTheme, Dialog, DialogActions, DialogContent, IconButton, InputAdornment, MenuItem, Select, TextField, ThemeProvider, Typography } from '@material-ui/core';

// @material-ui/icons
import { ReactComponent as CSVIcon } from "assets/img/tuzo/icons/CSVIcon.svg";
import { Search } from '@material-ui/icons';


// stylings
import Style from 'assets/jss/material-dashboard-pro-react/views/reportsStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import { zip } from 'lodash';




export function ReportsFilter(props) {
    const {
        classes,
        history,
        reportSelections,
        sortValue,
        batchInfoArr,
        copyArr,
        headers,
        numberFormatterDecimals,
        numberFormatter,
        searchString,
        setSearchString,
        handleSearch,
        filterArr,
        filterValue,
        setFilterValue,
        handleFilterReport,
        setData
    } = props;

    const today = moment().format("MMMM DD YYYY");

    const fixedDropdown = createTheme({
        overrides: {
            MuiMenu: {
                paper: {
                    top: "195px !important",
                },
            },
        },
    });

    return (
        <div>
            <GridContainer>
                <GridItem xs={4} >
                    <div style={{ display: "flex", }}>
                        <Typography variant="h2" className={classes.filterDesc} >
                            Switch Report
                        </Typography>
                        <Select
                            className={classes.selectMenuSortReportsPage}
                            value={sortValue}
                            disableUnderline
                            classes={{
                                root: classes.selectText,
                            }}
                            onChange={(e) => {
                                history.push(e.target.value.link)
                            }}
                            displayEmpty
                            renderValue={
                                sortValue !== "" ? undefined : () => "Sales by Merchant"
                            }
                        >
                            {reportSelections.map((o, i) => {
                                return (
                                    <MenuItem
                                        key={i}
                                        value={o}
                                        classes={{
                                            root: classes.selectMenuItem,
                                        }}
                                    >
                                        {o.name}

                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </div>
                </GridItem>

                <GridItem xs={4}>
                    <div style={{ display: "flex" }}>
                        <Typography variant="h2" className={classes.filterDesc}>
                            Filter Report
                        </Typography>
                        <ThemeProvider theme={fixedDropdown}>
                            <Select
                                style={{ width: "60%" }}
                                className={classes.selectMenuFilterDate}
                                value={filterValue}
                                disableUnderline
                                classes={{
                                    root: classes.selectText,
                                }}
                                onChange={(e) => {
                                    setData(false)
                                    setFilterValue(e.target.value)
                                    handleFilterReport(copyArr, e.target.value)
                                }}
                            >
                                {filterArr.map((o, i) => {
                                    return (
                                        <MenuItem
                                            key={i}
                                            value={o}
                                            classes={{
                                                root: classes.selectMenuItem,
                                            }}
                                        >
                                            {o}

                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </ThemeProvider>
                    </div>
                </GridItem>


                <GridItem xs={4} style={{ display: "flex", justifyContent: "flex-end", }}>
                    <Button
                        className={classes.csvButton}
                    >
                        <CSVLink
                            style={{ color: "white" }}
                            headers={headers}
                            data={
                                batchInfoArr.map(d => ({
                                    merchantNumber: d.merchantNumber,
                                    name: d.merchantName,
                                    quantity: d.transactionCount,
                                    pointsEarned: numberFormatter.format(d.pointsEarned),
                                    dayTotal: numberFormatterDecimals.format(d.netAmount),
                                    reportDate: moment(d.reportDate).format("MM/DD/YY"),
                                    userBasisPts: d.userBasisPts,

                                }))
                            }
                            filename={`${today}_deposit_history`}
                        >
                            <CSVIcon style={{ marginRight: "10px", }} /> Export CSV

                        </CSVLink>
                    </Button>
                </GridItem>
            </GridContainer>
        </div >
    );
}

function mapStateToProps(state) {
    return {
        // nothing yet
    };
}

function mapDispatchToProps(actions) {
    return (dispatch) => ({

    });
}

export default withRouter(compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(ReportsFilter));
